import { render, staticRenderFns } from "./FooterAction.vue?vue&type=template&id=c9bea096"
import script from "./FooterAction.vue?vue&type=script&lang=js"
export * from "./FooterAction.vue?vue&type=script&lang=js"
import style0 from "./FooterAction.vue?vue&type=style&index=0&id=c9bea096&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports